import { FC } from 'react'

type CmpProps = {
  progress: number
  handleSeek: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const Timeline: FC<CmpProps> = ({ progress, handleSeek }) => {
  return (
    <div className="bg-alpha-white-60 relative left-0 h-0.5 w-full rounded-[3px]">
      <div
        className="slider-thumb relative h-full rounded-[3px] bg-white after:bottom-[-3px] after:translate-y-0"
        style={{ width: `${progress}%` }}
      />
      <input
        type="range"
        value={progress}
        onChange={handleSeek}
        min="0"
        max="100"
        step="0.1"
        className="range-thumb absolute bottom-[-5px] left-0 z-[1] h-3 w-full cursor-pointer opacity-0"
      />
    </div>
  )
}

export default Timeline
